import styled from 'styled-components';

export const FormHeadline = styled.h4`
  font-size: ${({ theme }) => theme.font.size.h4};
  font-weight: ${({ theme }) => theme.font.weight.default};
  margin: 50px 0 15px;
`;
